import { ICONS } from 'assets/icons';
import SettingsIcon from "../../../assets/customSVG/channels/SettingsIcon";
import { KeyOutlined } from '@ant-design/icons';
import WhatsAppIcon from '../../../assets/customSVG/Whatsapp';

export const settingsMenu = [
  {
    id: 1,
    name: 'Keywords',
    label: 'keywords',
    icon: SettingsIcon,
    iconType: 'custom',
    link: '/user/settings/keywords',
    // subMenu: [
    //   {
    //     id: 1,
    //     name: 'Keywords',
    //     label: 'keywords',
    //     link: '/user/settings/sequence/keywords',
    //     icon: ICONS?.keywordIcon,
    //   },
    //   // Add more sequence sub-items as needed
    // ],
  },
  {
    id: 2,
    icon: KeyOutlined,
    iconType: 'antd',
    name: 'API Keys',
    label: 'api-keys',
    link: '/user/settings/api-keys',
    // subMenu: [
    //   {
    //     id: 1,
    //     icon: SettingsIcon,
    //     name: 'Manage API Keys',
    //     label: 'Manage API Keys',
    //     link: '/user/settings/api-keys/manage',
    //   },
    // ],
  },
  {
    id: 3,
    name: 'WhatsApp Widget',
    label: 'whatsapp-widget',
    icon: WhatsAppIcon,
    iconType: 'custom',
    link: '/user/settings/whatsapp-widget',
  },
  // Add more main menu items as needed
];
